import { UrlsTable } from './urls-table';

export { UrlsTable };
